module.exports = __webpack_public_path__ + "static/media/adesivo_neoman.560f5215.png";